<template>
  <div class="rebates-summary-container">
    <!-- <vs-tabs v-if="source == 'clientPaymentDetails' || source == 'clientApproveSummary'" class="rebates-summary-tabs custom-vs-tabs slot-border-top">
      <vs-tab label="Shared List">
        <div class="tab-text">
          <SharedList :source="source" :sharedListData="sharedListData" />
        </div>
      </vs-tab>

      <vs-tab label="Direct List">
        <div class="tab-text">
          <DirectList :source="source" :directListData="directListData" />
        </div>
      </vs-tab>

      <vs-tab label="Auto-Renew List">
        <div class="tab-text">
          <AutoRenewList :source="source" :autoRenewListData="autoRenewListData" />
        </div>
      </vs-tab>
    </vs-tabs> -->

    <div id="grid-loader" class="vx-card vs-con-loading__container">
      <SharedList :source="source" :sharedListData="sharedListData" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-enterprise';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import '@/assets/scss/radix/extraComponents/agGridStyleOverride.scss';

// Import Separate List Components
import SharedList from '@/components/ag-grid-tables/rebates/rebates-summary/SharedList.vue';
import DirectList from '@/components/ag-grid-tables/rebates/rebates-summary/DirectList.vue';
import AutoRenewList from '@/components/ag-grid-tables/rebates/rebates-summary/AutoRenewList.vue';
import CustomList from '@/components/ag-grid-tables/rebates/rebates-summary/CustomList.vue';


export default {
  name: 'RebatesSummarySheet',
  components: {
    AgGridVue,
    SharedList,
    DirectList,
    AutoRenewList,
    CustomList
  },
  data() {
    return this.initData();
  },
  props: {
    sharedListData: {
      type: Array,
    },
    directListData: {
      type: Array,
    },
    autoRenewListData: {
      type: Array,
    },
    customListData: {
      type: Array,
    },
    source: {
      type: String,
      default: null
    }
  },
  watch: {
    windowWidth(val) {
      // Toggle colummn movable
      this.toggleColumnMovable(val);
      // Toggle colummn pinning
      this.toggleColumnPinned(val);
    },
  },
  computed: {
    windowWidth: function () {
      return this.$store.state.windowWidth;
    },
    user_role() {
      return JSON.parse(localStorage.getItem('userDetails')).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem('userDetails')).id;
    },
    status() {
      return event.node;
    },
    paginationPageSize() {
      if (this.gridApi) {
        return this.gridApi.paginationGetPageSize();
      } else {
        return 15;
      }
    },
    totalPages() {
      if (this.gridApi) {
        return this.gridApi.paginationGetTotalPages();
      } else {
        return 0;
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    initData() {
      return {
        selectedRowCount: '',
        gridOptions: {},
        maxPageNumbers: 7,
        gridApi: null,
        defaultColDef: {
          sortable: true,
          resizable: true,
          suppressMenu: true,
          suppressMovable: false,
          filterParams: {
            suppressAndOrCondition: true,
            newRowsAction: 'keep',
          },
        },
        rowClassRules: null,
        statusBar: null,
        sideBar: null,
        columnDefs: null,
        tableData: null,
        selectedPromos: [],
        // Cell Renderer Components
        components: {
          // CellRendererStatus,
        },
        globalSearchTerm: "",
        flags: {
          selectedAll: [],
        },
      };
    },
    onPageSizeChanged() {
      var value = document.getElementById("page-size").value;
      this.gridApi.paginationSetPageSize(Number(value));
    },
    onPaginationChanged() {
      if (this.gridApi) {
        (this.totalRows = this.gridApi.paginationGetRowCount()),
          (this.currentPageSize = this.gridApi.paginationGetPageSize());
      }
    },
    onRowSelected(event) {
      var getStatus = this.gridApi
        .getSelectedNodes()
        .map((x) => x.data)
        .map((x) => x.status);
      // FIXME: Change Non editable condition according to rebates requirement
      getStatus.includes("expired")
        ? (this.selectedNonEditableRow = true)
        : (this.selectedNonEditableRow = false);
      if (event.node.selected) {
        // Push to selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
        if (this.selectedRowCount > 30) {
          event.node.setSelected(false);

          this.$vs.notify({
            time: 5000,
            color: "warning",
            title: "Warning",
            text: "You may select only upto 30 rows",
          });
        }
      } else {
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      }
    },
    onFilterChanged() {
      this.deselectAllSelectedRows();
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },
    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef["suppressMovable"] = true;
      } else {
        this.defaultColDef["suppressMovable"] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
      } else {
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },
    disableQueue() {
      this.rowClassRules = {
        "ag-row-disabled": 'data && (data.status == "edit pending")',
        "ag-checkbox-disabled": 'data && (data.status == "edit pending")',
        // "ag-row-red": 'data && (data.status == "expired")'
      };
    },
    // Refresh the page withou resetting filters
    refreshPage() {
      this.initSelectedAllFlag();
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
    },
    // With filters for when we want to reset filters
    refreshPageWithFilters() {
      this.refreshPage();
      // Reset filters
      this.gridApi.setFilterModel(null);
    },
    gridSelectAll() {
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (
          !(
            node.data.status == "new approved" ||
            node.data.status == "rejected" ||
            node.data.status == "error"
          )
        ) {
          if (
            node["rowIndex"] >=
              (this.currentPage - 1) * this.gridApi.paginationGetPageSize() &&
            node["rowIndex"] <
              this.currentPage * this.gridApi.paginationGetPageSize()
          ) {
            node.setSelected(true);
          }
        }
      });
    },
    gridDeselectAll() {
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (
          node["rowIndex"] >=
            (this.currentPage - 1) * this.gridApi.paginationGetPageSize() &&
          node["rowIndex"] <
            this.currentPage * this.gridApi.paginationGetPageSize()
        ) {
          node.setSelected(false);
        }
      });
    },
    scheduleRebates() {
      // TODO: Add API to manually Schedule Rebates
    },
    editScheduledRebate() {
      // TODO: Add API to manually edit Scheduled Rebates
    },
    deleteScheduledRebate() {
      // TODO: Add function to delete Scheduled Rebates
    },
    downloadData() {
      // TODO: Add function for download of data
      this.$root.$emit("downloadRebatesSummarySheet");
    },
    toggleSelectAll() {
      if (this.flags["selectedAll"][this.currentPage - 1]) {
        this.gridDeselectAll();
        this.flags["selectedAll"][this.currentPage - 1] =
          !this.flags["selectedAll"][this.currentPage - 1];
      } else {
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
        if (this.selectedRowCount < 30 && this.selectedRowCount + 15 <= 30) {
          this.gridSelectAll();
          this.flags["selectedAll"][this.currentPage - 1] =
            !this.flags["selectedAll"][this.currentPage - 1];
        } else {
          this.$vs.notify({
            time: 5000,
            color: "warning",
            title: "Warning",
            text: "You may select only upto 30 rows",
          });
        }
      }
    },
    onFilterTextBoxChanged() {
      this.gridApi.setQuickFilter(
        document.getElementById("filter-text-box").value
      );
      this.deselectAllSelectedRows();
    },
    initSelectedAllFlag() {
      if (this.tableData.length) {
        for (let i = 0; i < this.gridApi.paginationGetTotalPages(); i++) {
          this.flags["selectedAll"].push(false);
        }
      }
    },
    deselectAllSelectedRows() {
      this.gridApi.deselectAll();

      this.flags["selectedAll"].fill(false);
    },
    // Total Aggregate Data Row functions
    generatePinnedBottomData() {
      // generate a row-data with null values
      let result = {};

      this.gridColumnApi.getAllGridColumns().forEach((item) => {
        result[item.colId] = null;
      });

      return this.calculatePinnedBottomData(result);
    },
    calculatePinnedBottomData(target) {
      //**list of columns for aggregation**
      let columnsWithAggregation = [
        "net_revenue",
        "count",
        "sum_rebate",
        "sum_cost_adjustment",
        "sum_radix_revenue",
      ];
      columnsWithAggregation.forEach((element) => {
        this.gridApi.forEachNodeAfterFilter((rowNode) => {
          if (rowNode.data[element])
            target[element] += Number(rowNode.data[element]);
        });

        if (target[element]) target[element] = `${target[element].toFixed(2)}`;
      });
      return target;
    },
  },
  beforeMount() {
    this.disableQueue();

    // Reset movable columns on mobile
    this.toggleColumnMovable(this.windowWidth);

    (this.columnDefs = [
      {
        headerName: "Type",
        field: "type",
        cellRenderer: (data) => {
          return this.toTitleCase(data.data.type);
        },
        minWidth: 150,
        width: 120,
      },
      {
        headerName: "Year",
        field: "year",
        minWidth: 150,
        width: 120,
      },
      {
        headerName: "Month",
        field: "month",
        minWidth: 150,
        width: 100,
      },
      {
        headerName: "Promo Tag",
        field: "promo_tag",
        minWidth: 150,
        width: 150,
      },
      {
        headerName: "TLD",
        field: "tld",
        minWidth: 150,
        width: 100,
      },
      {
        headerName: "Period",
        field: "period",
        minWidth: 150,
        width: 100,
      },
      {
        headerName: "Net Revenue",
        field: "net_revenue",
        minWidth: 150,
        width: 150,
      },
      {
        headerName: "Count",
        field: "count",
        minWidth: 150,
        width: 100,
      },
      {
        headerName: "Sum Rebate",
        field: "sum_rebate",
        minWidth: 150,
        width: 150,
      },
      {
        headerName: "Sum Cost Adj",
        field: "sum_cost_adjustment",
        minWidth: 150,
        width: 150,
      },
      {
        headerName: "Sum Radix Rev.",
        field: "sum_radix_revenue",
        minWidth: 150,
        width: 150,
      },
    ]),
      // Set Grid sidebar
      (this.sideBar = {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressSideButtons: true,
              suppressColumnSelectAll: true,
              suppressColumnExpandAll: true,
            },
          },
        ],
      });
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>
